import React from "react";
import "./AttractiveFeatures.css";

const FeatureItem = ({ icon, title, description }) => {
  return (
    <div className="feature-1">
      <div className="headerSection">
        <img className="icons1" alt="" src={icon} />
        <div className="titlesSection">
          <h2 className="titles">{title}</h2>
        </div>
      </div>
      <h3 className="description">{description}</h3>
    </div>
  );
};

export default FeatureItem;
